import script from "./TicketsCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsCreate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__